module.exports = __webpack_public_path__ + "static/media/A1.74abfe81.jpg";